<app-warehouse-select style="margin-top: 5px"></app-warehouse-select>
<div class="clearfix"></div>
<router-outlet></router-outlet>
